import React from 'react';
import PropTypes from 'prop-types';
import {compose} from 'recompose';
import {reduxForm, propTypes as formPropTypes} from 'redux-form';
import block from 'bem-cn-lite';
import {TextInput, YCSelect, Spin} from '@yandex-data-ui/common';

import withTranslation from 'hoc/withTranslation';
import Arrows from 'components/TranslateDemo/TranslateDemoArrows/TranslateDemoArrows';
import TranslateDemoError from 'components/TranslateDemo/TranslateDemoError/TranslateDemoError';

import './TranslateDemoForm.scss';

const b = block('TranslateDemoForm');
const form = 'translateDemoFormDemo';

const VIRTUALIZE_THRESHOLD = 40;

class Form extends React.PureComponent {
    static propTypes = {
        ...formPropTypes,

        showLoader: PropTypes.bool,
        isAutoDetecting: PropTypes.bool,
        isInit: PropTypes.bool,
        isTranslated: PropTypes.bool,

        languages: PropTypes.arrayOf(
            PropTypes.shape({
                value: PropTypes.string,
                title: PropTypes.string,
                key: PropTypes.string,
            }),
        ),
        text: PropTypes.string,
        fromLang: PropTypes.string,
        toLang: PropTypes.string,

        handleTextChange: PropTypes.func,
        handleFrom: PropTypes.func,
        handleTo: PropTypes.func,
        handleExchange: PropTypes.func,

        errorText: PropTypes.string,
        onTranslateError: PropTypes.func,

        className: PropTypes.string,

        i18nK: PropTypes.func,
    };

    render() {
        const {
            handleTextChange,
            handleFrom,
            handleTo,
            showLoader,
            errorText,
            isInit,
            text,
            fromLang,
            toLang,
            isTranslated,
            translatedText,
            languages,
            handleExchange,
            onTranslateError,
            isAutoDetecting,
            className,
            i18nK,
        } = this.props;

        return (
            <form className={b(null, className)}>
                <div className={b('content')}>
                    <div className={b('side')}>
                        <TextInput
                            className={b('text-area')}
                            multiline={true}
                            view="clear"
                            size="xl"
                            name="text"
                            rows={5}
                            id="text"
                            placeholder={i18nK('textarea-placeholder')}
                            value={text}
                            onUpdate={(value) => handleTextChange(value)}
                        />
                        <div className={b('select-wrapper')}>
                            {isAutoDetecting ? (
                                <div className={b('color-grey')}>
                                    {i18nK('textarea-autodetecting')}
                                </div>
                            ) : (
                                !isInit && (
                                    <YCSelect
                                        className={b('select', {directipn: 'to'})}
                                        popupClassName={b('popup')}
                                        value={fromLang}
                                        items={languages}
                                        onUpdate={handleFrom}
                                        virtualizeThreshold={VIRTUALIZE_THRESHOLD}
                                        size="n"
                                    />
                                )
                            )}
                        </div>
                    </div>
                    <div className={b('side', {init: isInit})}>
                        <div className={b('result-field')}>
                            {showLoader ? <Spin size="s" /> : translatedText}
                        </div>
                        <div className={b('select-wrapper')}>
                            {!isInit && (
                                <YCSelect
                                    className={b('select', {directipn: 'to'})}
                                    popupClassName={b('popup')}
                                    value={toLang}
                                    items={languages}
                                    onUpdate={handleTo}
                                    virtualizeThreshold={VIRTUALIZE_THRESHOLD}
                                    size="n"
                                />
                            )}
                            {isTranslated && <Arrows handleExchange={handleExchange} />}
                        </div>
                    </div>
                </div>
                {!showLoader && errorText && (
                    <TranslateDemoError handleClick={onTranslateError}>
                        {errorText}
                    </TranslateDemoError>
                )}
            </form>
        );
    }
}

export default compose(withTranslation('translate-demo'), reduxForm({form}))(Form);
